// ** Redux toolkit
import { isFulfilled } from '@reduxjs/toolkit';

// ** Third Party
import { toast } from 'react-toastify';

export const SuccessHandler = api => next => action => {
  if (isFulfilled(action)) {
    const method = action?.meta?.baseQueryMeta?.request?.method;
    const isMutation =
      action?.meta?.arg?.type === 'mutation' ||
      (typeof action?.type === 'string' &&
        action.type.includes('/executeMutation/'));

    const endpointName = action?.meta?.arg?.endpointName;
    const isGetDocumentDownloadUrl = endpointName === 'getDocumentDownloadUrl';

    const isNonGet =
      isMutation || (method ? method.toUpperCase() !== 'GET' : false);

    if (isNonGet && !isGetDocumentDownloadUrl) {
      if (
        (action && action.payload && action.payload.result) ||
        (action && action.payload && action.payload)
      ) {
        toast.success(action.payload.message || 'Success');
      } else {
        toast.success('Success');
      }
    }
  }

  return next(action);
};
